import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { isBefore, isAfter, startOfToday } from 'date-fns';
import { useEventCallback } from '@cian/react-utils';
export function useCurrentDate(selected, min, max) {
  var _React$useState = React.useState(function () {
      var value = selected || startOfToday();
      return normalize(value, min, max);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var setCurrentDate = useEventCallback(function (nextValue) {
    setValue(normalize(nextValue, min, max));
  });
  return [value, setCurrentDate];
}
function normalize(date, min, max) {
  if (min && isBefore(date, min)) {
    return min;
  }
  if (max && isAfter(date, max)) {
    return max;
  }
  return date;
}